import React from 'react'
import assetData from './AirbusAssetData'
import "./style.css"

const AirbusAssetListComponent = (props) => {
    return (
        <div style={{ backgroundColor: "rgb(9 24 59)" }}>
            <div className="container-fluid p-2 px-4">
                <div className="card mb-3 shadow-lg">
                    <div className="card-body d-flex justify-content-between">
                        <h2 style={{ color: "rgb(9 24 59)" }}><b>Contract Assets</b></h2>
                        <button className='btn btn-info me-4' onClick={() => { props.navigate(-1) }}><b>Back</b></button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <table id="customers">
                            <thead>
                                <tr>
                                    <th scope="col">sNo.</th>
                                    <th scope="col">Asset Name</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assetData.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.name}</td>
                                            <td>{item.Quantity}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AirbusAssetListComponent